import React from "react";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

export default class CreatingExecutorModal extends React.PureComponent {
  render() {
    const { isCreatingExecutor } = this.props;
    return (
      <Dialog open={isCreatingExecutor}>
        <DialogContent size="sm">
          <DialogHeader>
            <DialogTitle>{"Creating Account Executor..."}</DialogTitle>
            <DialogDescription>{"This should take a couple minutes..."}</DialogDescription>
          </DialogHeader>

          <LoadingIndicator />
        </DialogContent>
      </Dialog>
    );
  }
}
